import { InterventionCategory, Intervention, Suggestion } from '@/types';
import { useState, useCallback } from 'react';
import { identify } from '@/data/identify';
import { noop } from 'lodash/fp';
import {
  Heading,
  Container,
  Frame,
  Content,
  Stack,
  Inline,
  InlineItem,
  Button,
  Menu,
  MenuItem,
} from '@kinesis/bungle';
import { Layout } from '@/components/layout';
import { InterventionDetail } from '@/components/intervention-detail';

const blank = {
  name: '',
  description: '',
  type: undefined,
};

const InterventionNew = (props: InterventionNewProps) => {
  const { suggestions = [], category, onCreate = noop } = props;
  const [intervention, setIntervention] = useState<
    Intervention | IncompleteIntervention
  >(identify(blank));
  const onReset = useCallback(() => {
    setIntervention(identify(blank));
  }, [setIntervention]);
  const onAddIntervention = useCallback(() => {
    // FIX validate intervention is complete
    onCreate(intervention as Intervention);
  }, [intervention, onCreate]);

  return (
    <Content padding='none' height='100%'>
      <Container>
        <Frame sizing='fill-container'>
          <Layout>
            <Stack space='large'>
              <InterventionDetail
                intervention={intervention as Intervention}
                onUpdate={setIntervention as any}
                category={category}
                allowTypeChange
                autoFocus
              />
              <Inline>
                <InlineItem sizing='fill-container' />
                <InlineItem sizing='fit-content'>
                  <Button variant='secondary' onClick={onReset}>
                    Reset
                  </Button>
                </InlineItem>
                <InlineItem sizing='fit-content'>
                  <Button variant='primary' onClick={onAddIntervention}>
                    Add intervention
                  </Button>
                </InlineItem>
              </Inline>
            </Stack>
          </Layout>
        </Frame>
        {suggestions.length > 0 && (
          <Frame sizing='fit-content'>
            <Content padding='medium' width={320} height='100%' borderLeft>
              <Stack space='medium'>
                <Heading as='h4' size='small'>
                  suggestions
                </Heading>
                <Menu>
                  {suggestions
                    .filter((s: any) => s.area === category)
                    .map((s: any) => (
                      <MenuItem
                        icon='bulb'
                        content={s.name}
                        key={s.name}
                        onClick={() =>
                          setIntervention(
                            identify({
                              tag: 'current',
                              ...s,
                            }),
                          )
                        }
                      />
                    ))}
                </Menu>
              </Stack>
            </Content>
          </Frame>
        )}
      </Container>
    </Content>
  );
};

export type IncompleteIntervention = {
  name: string;
  description: string;
  type: undefined;
};

export type InterventionNewProps = {
  suggestions?: Suggestion[];
  category: InterventionCategory;
  onCreate?: (intervention: Intervention) => void;
};

export { InterventionNew };
